<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!auction">
      <span class="loader"></span>
    </span>
    <div v-if="auction" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        value="global"
        v-model="activeTab"
      >
        <tab-pane title="global" id="1" :active="true">
          <span slot="title">
            <i class="ni ni-cloud-upload-96"></i>
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <auction-view-global v-if="alreadyLoadedTabs.includes('1')"
            v-show="activeTab === '1'" :auction="auction" @auctionUpdated="get" @onExtractDetails="extractAuctionDetails" />
        </tab-pane>

        <tab-pane title="properties" id="2">
          <span slot="title">
            <i class="ni ni-building"></i>
            {{ $t("COMMON.PROPERTIES") }}
          </span>
          <auction-view-properties v-if="alreadyLoadedTabs.includes('2')"
            v-show="activeTab === '2'" :auction="auction" @auctionUpdated="get" />
        </tab-pane>

        <tab-pane title="fees" id="3">
          <span slot="title">
            <i class="ni ni-money-coins"></i>
            {{ $t("AUCTIONS.FEES_TAB") }}
          </span>
          <auction-view-fees v-if="alreadyLoadedTabs.includes('3')"
            v-show="activeTab === '3'" :auction="auction" @onAppliedFeeUpdated="appliedFeeUpdated" :key="componentKey" />
        </tab-pane>

        <tab-pane title="bidSteps" id="4">
          <span slot="title">
            <i class="ni ni-settings"></i>
            {{ $t("COMMON.BID_STEPS") }}
          </span>
          <auction-view-bid-steps v-if="alreadyLoadedTabs.includes('4')"
            v-show="activeTab === '4'" :auction="auction" />
        </tab-pane>

        <tab-pane
          title="logs"
          id="5"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
        >
          <span slot="title">
            <i class="fa fa-file"></i>
            {{ $t("COMMON.LOGS") }}
          </span>
          <auction-view-logs v-if="alreadyLoadedTabs.includes('5')"
            v-show="activeTab === '5'" :auction="auction" />
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { Tabs, TabPane } from "@/components";
import AuctionViewGlobal from "../partials/AuctionViewGlobal.vue";
import AuctionViewLogs from "../partials/AuctionViewLogs.vue";
import AuctionViewProperties from "../partials/AuctionViewProperties.vue";
import AuctionViewFees from "../partials/AuctionViewFees.vue";
import AuctionViewBidSteps from "../partials/AuctionViewBidSteps.vue";
import swal from "sweetalert2";
import moment from "moment";

export default {
  layout: "view-auction-component",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    AuctionViewGlobal,
    AuctionViewLogs,
    AuctionViewProperties,
    AuctionViewFees,
    AuctionViewBidSteps,
  },

  mixins: [],

  props: {
    auctionId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      auction: null,
      componentKey: 0,
      activeTab: '1',
      alreadyLoadedTabs: ['1']
    };
  },

  computed: {},

  watch: {
    activeTab(newTab) {
      if (!this.alreadyLoadedTabs.includes(newTab)) {
        this.alreadyLoadedTabs.push(newTab);
      }
    }
  },

  created() {
    this.get();
  },

  methods: {
    
    async get() {
      try {
        await this.$store.dispatch("auctions/get", this.auctionId);
        this.auction = this.$store.getters["auctions/auction"];

        this.$emit("auctionChange", this.auction);
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
    appliedFeeUpdated(){
      this.componentKey += 1;
    },
    async extractAuctionDetails() {
      swal.fire({
        title: `Chargement`,
        onBeforeOpen: () => {
          swal.showLoading();
        },
      });
      try {
        const pdfResponse = await this.$store.dispatch(
          "auctions/extractAuctionDetails",
          {id:this.auction.id}
        );

        const pdfPath = window.URL.createObjectURL(
          new Blob([pdfResponse.data], { type: "application/pdf" })
        );

        const downloadPdfLink = document.createElement("a");
        downloadPdfLink.href = pdfPath;
        downloadPdfLink.download =
          'encan-' + this.auction.name + '-' +
          moment().format("DD/MM/YYYY_HH_mm_ss") +
          ".pdf";

        document.body.appendChild(downloadPdfLink);
        downloadPdfLink.click();
        document.body.removeChild(downloadPdfLink);

        swal.close();
        this.showModal = false;
      } catch (error) {
        console.log('extractAuctionDetails', error);
        swal.close();
        if (error?.response?.status === 404) {
          this.$notify({
            type: "danger",
            message: this.$t("ERRORS.NO_PROPERTY_FOUND"),
          });
        } else {
          this.$notify({
            type: "danger",
            message: "Oops, something went wrong!",
          });
        }
      }
    },
  },
};
</script>
